const initialState = {users:[
    {id:1 , firstName:'ahmad' , lastName:'morid' , age:17 },
    {id:2 , firstName:'sara' , lastName:'echibi' , age:30 },
    {id:3 , firstName:'oussama' , lastName:'einchtein' , age:21 },
],
user:{}}
 const UserReducer = (state=initialState, action)=>{
    switch(action.type){
        case 'CREATE_USER':
            return {...state , users:[...state.users , action.payload]}
        case 'UPDATE_USER':
            var user = state.users.find(u=>u.id === parseInt(action.payload.id))
            if(user){
                user.firstName = action.payload.firstName
                user.lastName = action.payload.lastName
                user.age = action.payload.age
            }
            return state
        case 'SHOW_USER':
            return {...state , user: action.payload}
        case 'DELETE_USER':
            return {...state, users : [...state.users.filter(u=>u.id!== action.payload.id)]} 
            default :
            return state
    }
}
export default  UserReducer 